import IPNetworksManageData from './IPNetworksManageData';

export default IPNetworksManageData;
